import { useState, useMemo } from 'react';

export const useProductFiltering = (products, upgradeInfo) => {
  const [selectedBrowsingGroup, setSelectedBrowsingGroup] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  // Extract BrowsingGroup values
  const browsingGroups = useMemo(() => {
    const browsingGroupSet = new Set();
    Object.values(products).forEach(product => {
      const group = product.BrowsingGroup || 'Others';
      browsingGroupSet.add(group);
    });
    // Sort with "Others" at the end
    return Array.from(browsingGroupSet).sort((a, b) => {
      if (a === 'Others') return 1;
      if (b === 'Others') return -1;
      return a.localeCompare(b);
    });
  }, [products]);

  const filteredProducts = useMemo(() => {
    return Object.values(products).filter(product => {
      const productGroup = product.BrowsingGroup || 'Others';
      const groupMatch = selectedBrowsingGroup === 'all' || productGroup === selectedBrowsingGroup;
      const searchMatch = searchTerm === '' || 
        product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        productGroup?.toLowerCase().includes(searchTerm.toLowerCase());
      
      // If upgrade active, hide the already owned set
      const isAlreadyOwned = upgradeInfo?.eligible && product.id === upgradeInfo.highestSet.sku;
      
      // If upgrade active, hide any SET with lower or equal value than the highest set
      let isLowerOrEqualValue = false;
      if (upgradeInfo?.eligible && product.BrowsingGroup === 'SET') {
        const productPrice = product.prices?.[upgradeInfo.highestSet.currency] || product.prices?.USD || 0;
        const highestSetPrice = upgradeInfo.highestSet.priceLocal || 0;
        isLowerOrEqualValue = productPrice <= highestSetPrice;
      }
      
      return groupMatch && searchMatch && !isAlreadyOwned && !isLowerOrEqualValue;
    });
  }, [products, selectedBrowsingGroup, searchTerm, upgradeInfo]);

  return {
    selectedBrowsingGroup,
    setSelectedBrowsingGroup,
    searchTerm,
    setSearchTerm,
    browsingGroups,
    filteredProducts
  };
};
